<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" [innerText]="id==='0'?'Yeni Rota':'Rota Düzenle'"></h4>
          <div class="card-options">
            <button class="btn btn-sm btn-pill btn-success" (click)="save()"
              [innerText]="id==='0'? 'Oluştur':'Değişiklikleri Kaydet'"></button>
          </div>
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-lg-8 col-md-12">
              <div class="card p-0">
                <div class="card-header">
                  <h3 class="card-title">Cari: {{secilenCari?.firmaUnvani}}</h3>
                </div>
                <div class="card-body border-bottom py-3">
                  <div class="d-flex">
                    <div class="mr-auto text-muted">
                      Arama yap:
                      <div class="ml-2 d-inline-block">
                        <div class="input-icon mb-3">
                          <span class="input-icon-addon" style="left:auto;right:0;" *ngIf="cariAraLoading">
                            <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                          </span>
                          <input name="cariAra" [autocomplete]="true" type="text" class="form-control form-control-sm"
                            [(ngModel)]="cariAraText" placeholder="Yazın ve Enter'a basın"
                            (keyup.enter)="cariAraInputChange()">
                        </div>
                      </div>
                    </div>
                    <div class="text-muted">
                      Gösterilen
                      <div class="mx-2 d-inline-block">
                        <select class="form-control form-control-sm" [(ngModel)]="showSearchResultCountCari"
                          (change)="cariAraInputChange()">
                          <option *ngFor="let p of showSearchResultCountModelCari" [ngValue]="p">{{p}}</option>
                        </select>
                      </div>
                      sonuç sayısı
                    </div>
                  </div>
                </div>
                <div class="table-responsive" *ngIf="searchResultsCari && searchResultsCari.results">
                  <table class="table card-table table-vcenter text-nowrap datatable">
                    <thead>
                      <tr>
                        <th class="w-1">Cari Kodu</th>
                        <th>Firma Unvanı</th>
                        <th>Şehir</th>
                        <th>Telefon</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let c of searchResultsCari.results;let i=index" class="">
                        <td><span class="text-muted">{{c.cariKodu}}</span></td>
                        <td>{{c.firmaUnvani}}</td>
                        <td>{{c.sehir?.aciklama}}</td>
                        <td>{{c.telefon}}</td>
                        <td class="text-right">
                          <button class="btn btn-sm btn-success" (click)="addCari(c)">Seç</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="card-footer d-flex align-items-center" *ngIf="searchResultsCari">
                  <p class="m-0 text-muted"><span>{{searchResultsCari.rowCount}}
                      sonuçtan
                      {{searchResultsCari.firstRowOnPage}}</span>-<span>{{searchResultsCari.lastRowOnPage}}</span>
                    arası
                    sonuçlar
                  </p>
                  <ul class="pagination m-0 ml-auto">
                    <li class="page-item" [ngClass]="{'disabled':showSearchCurrentPageCari === 1}">
                      <div class="page-link" tabindex="-1" (click)="showPreviousPageSearchResultsCari()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                          stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z"></path>
                          <polyline points="15 6 9 12 15 18"></polyline>
                        </svg>
                        önceki
                      </div>
                    </li>
                    <li class="page-item"
                      [ngClass]="{'disabled':showSearchCurrentPageCari === searchResultsCari.pageCount}">
                      <div class="page-link" (click)="showNextPageSearchResultsCari()">
                        sonraki
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24"
                          stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                          stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z"></path>
                          <polyline points="9 6 15 12 9 18"></polyline>
                        </svg>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-4">
              <div class="mb-3">
                <div class="form-label">Şube</div>
                <app-loading-input *ngIf="!subeler"></app-loading-input>
                <select *ngIf="subeler" class="form-control" [(ngModel)]="lojistik.subeId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of subeler" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="mb-3">
                <div class="mb-3">
                  <label class="form-label">Fiyatlama Tarihi</label>
                  <input mwlFlatpickr class="form-control mb-2 flatpickr-input" type="text"
                    placeholder="Fiyatlama Tarihi" [altInput]="true" [convertModelValue]="true"
                    [(ngModel)]="lojistik.tarih">
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="mb-3">
                <label class="form-label">Mazot Baz Fiyatı</label>
                <div class="input-icon">
                  <input type="number" class="form-control" [(ngModel)]="lojistik.mazotBazFiyati">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="mb-3">
                <label class="form-label">Açıklama</label>
                <textarea class="form-control" name="example-textarea-input" rows="6" placeholder="Açıklama.."
                  [(ngModel)]="lojistik.aciklama"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="(id != '0') && (userGroupId == 1 || userGroupId == 5 || userGroupId == 6)">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Enflasyon Değişimi</h3>
        </div>
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">%</span>
              </div>
              <input type="number" class="form-control" [(ngModel)]="enflasyon" />
            </div>
            <div class="form-check ml-2">
              <input type="checkbox" [(ngModel)]="enflasyonArtis" class="form-check-input" id="enflasyonArtis"/>
              <label class="form-check-label text-nowrap" for="enflasyonArtis">Artış</label>
            </div>
            <button (click)="enflasyonGuncelle()" class="btn btn-primary ml-2">Güncelle</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6" *ngIf="(id != '0') && (userGroupId == 1 || userGroupId == 5 || userGroupId == 6)">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Güncel Yakıt Fiyatı</h3>
        </div>
        <div class="card-body">
          <div class="d-flex">
            <input class="form-control" type="date" [(ngModel)]="guncelYakitTarih">
            <button class="btn btn-success text-nowrap ml-2" (click)="getSonZamlar()">Onay Listesini Getir</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="(id != '0') && (userGroupId == 1 || userGroupId == 5 || userGroupId == 6)">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Onaylanabilir Güncel Yakıt Fiyatları</h3>
        </div>
        <div class="card-body">
          <div class="table-reponsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-50">Güncelleme Tarihi</th>
                  <th class="w-25">Fiyat</th>
                  <th class="w-25">Değişim Oranı</th>
                  <th>Onaylama</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let zam of sonZamlar">
                  <td>{{zam.guncellemeTarihi}}</td>
                  <td>{{zam.fiyat}}</td>
                  <td>{{zam.degisimOran}}</td>
                  <td>
                    <button class="btn btn-sm btn-success" (click)="yakitGuncellemeOnay(zam)">Onayla</button>
                    <button class="btn btn-sm btn-danger ml-2" (click)="yakitGuncellemeGizle(zam)">Gizle</button>
                  </td>
                </tr>
                <tr *ngIf="!sonZamlar.length">
                  <td colspan="4" class="text-center">
                    <b>{{ arananGuncelYakitTarih }}</b> tarihinden itibaren onaylanacak bir güncelleme bulunamamaıştır.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="id != '0'" >
      <div class="card p-0">
        <div class="card-header justify-content-between">
          <h3 class="card-title">Rota Bilgileri</h3>
          <div class="d-flex align-items-center text-secondary mb-0 pb-0 h5">
            <span class="text-nowrap font-weight-bold" data-toggle="tooltip" #excelinfo data-placement="bottom" [title]="excelInfoText">Örnek Excel Bilgileri</span>
            <input #file type="file" (change)="uploadExcel()" class="d-none" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
            <button class="btn btn-sm btn-success ml-2" (click)="chooseExcel()">Excel Yükle</button>
          </div>
        </div>
        <div class="table-responsive">
          <table *ngIf="guzergahList.length > 0" class="table card-table table-vcenter text-nowrap datatable">
            <thead>
              <tr>
                <th>Başlangıç</th>
                <th>Varış</th>
                <th>Km</th>
                <th>Ürün Cinsi</th>
                <th>Araç Tipi</th>
                <th>Boş-Dolu</th>
                <th>Fiyat</th>
                <th>Aktif Mazot Fiyat</th>
                <th>Değişim Yüzdesi</th>
                <th>Değişen Fiyat</th>
                <th>
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr *ngFor="let r of lojistik.rotalar;let i=index;" [id]="'cart'+i">
                <td><select *ngIf="lokasyonList" class="form-control" [(ngModel)]="r.baslangicId"
                    [ngModelOptions]="{standalone: true}">
                    <z!-- <option [value]="1" selected>Şeçiniz</option> 
                    <option *ngFor="let l of lokasyonList" [ngValue]="l.id">{{l.aciklama}}</option>
                  </select>
                </td>
                <td><select *ngIf="lokasyonList" class="form-control" [(ngModel)]="r.varisId"
                    [ngModelOptions]="{standalone: true}">
                    <z!-- <option [value]="1" selected>Şeçiniz</option> 
                    <option *ngFor="let l of lokasyonList" [ngValue]="l.id">{{l.aciklama}}</option>
                  </select>
                </td>
                <td><input type="number" class="form-control" [(ngModel)]="r.km"></td>
                <td><select *ngIf="urunCinsiList" class="form-control" [(ngModel)]="r.urunCinsiId"
                    [ngModelOptions]="{standalone: true}">
                    <z!-- <option [value]="1" selected>Şeçiniz</option> 
                    <option *ngFor="let u of urunCinsiList" [ngValue]="u.id">{{u.aciklama}}</option>
                  </select>
                </td>
                <td><select *ngIf="aracTipiList" class="form-control" [(ngModel)]="r.aracTipiId"
                    [ngModelOptions]="{standalone: true}">
                    <z!-- <option [value]="1" selected>Şeçiniz</option> 
                    <option *ngFor="let a of aracTipiList" [ngValue]="a.id">{{a.aciklama}}</option>
                  </select>
                </td>
                <td><select class="form-control" [(ngModel)]="r.bosDolu" [ngModelOptions]="{standalone: true}">
                    <option [value]=null selected></option>
                    <option [value]=1>Boş/Dolu</option>
                    <option [value]=2>Dolu/Dolu</option>
                  </select>
                </td>
                <td><input type="number" class="form-control" [(ngModel)]="r.fiyat"></td>
                <td class="text-right">
                  <div class="btn btn-sm btn-danger" (click)="removeFromRequestList(i)">Kaldır</div>
                </td>
              </tr> -->
              <tr *ngFor="let r of guzergahList;">
                <td> {{r.baslangicBolge.bolge}} </td>
                <td>{{r.varisBolge.bolge}}</td>
                <td>{{r.lojistik.km}}</td>
                <td>{{r.lojistik.stokKodu}}</td>
                <td>{{r.aracTipi.name}}</td>
                <td>{{r.lojistik.bosDolu == 1 ? "Boş/Dolu" : "Dolu/Dolu" }}</td>
                <td>{{r.lojistik.fiyat}}</td>
                <td>{{r.mazotFiyat}}</td>
                <td>{{degisimYuzdesi(r.mazotFiyat)}}</td>
                <td>{{degisimFiyat(r.lojistik.fiyat, r.mazotFiyat)}}</td>
                <td>
                  <button class="btn btn-danger" (click)="guzergahKaldir(r.lojistik.id)">Sil</button>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center p-3" *ngIf="guzergahList.length === 0">
            Rota Eklenmedi!
          </div>
        </div>
      </div>
    </div>

    <div class="col-12" *ngIf="id != '0'">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title" [innerText]="id==='0'?'Yeni Rota':'Rota Düzenle'"></h4>
        </div>

        <div class="card-body">

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <div class="form-label">Başlangıç</div>
                <app-loading-input *ngIf="!guzergahType?.bolgeler"></app-loading-input>
                <select *ngIf="guzergahType?.bolgeler" class="form-control" [(ngModel)]="baslangicId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let l of guzergahType?.bolgeler" [ngValue]="l.id">{{l.bolge}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <div class="form-label">Varış</div>
                <app-loading-input *ngIf="!guzergahType?.bolgeler"></app-loading-input>
                <select *ngIf="guzergahType?.bolgeler" class="form-control" [(ngModel)]="varisId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let l of guzergahType?.bolgeler" [ngValue]="l.id">{{l.bolge}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <div class="form-label">Fiyatlama Türü</div>
                <select  class="form-control" [(ngModel)]="fiyatlamaTuru"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option value="0">Km</option>
                  <option value="1">Tonaj</option>
                </select>
              </div>
            </div>


            <div class="col-md-4">
              <div class="mb-3">
                <label class="form-label"  *ngIf="fiyatlamaTuru==0">Sefer</label>
                <label class="form-label"  *ngIf="fiyatlamaTuru==1">Tonaj</label>
                <div class="input-icon">
                  <input type="number" class="form-control" [(ngModel)]="km">
                </div>
              </div>
            </div>

            <div class="col-md-4" *ngIf="fiyatlamaTuru==0">
              <div class="mb-3">
                <label class="form-label">Sefer Fiyatı</label>
                <div class="input-icon">
                  <input type="number" class="form-control">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-lg-4">
              <div class="mb-3">
                <div class="form-label">Ürün Cinsi</div>
                <app-loading-input *ngIf="!guzergahType?.stokListe"></app-loading-input>
                <select *ngIf="guzergahType?.stokListe" class="form-control" [(ngModel)]="urunCinsiId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let l of guzergahType?.stokListe" [ngValue]="l.stokKodu">{{l.stokAdi}}({{l.stokKodu}})</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-4">
              <div class="mb-3">
                <div class="form-label">Araç Tipi</div>
                <app-loading-input *ngIf="!guzergahType?.carTypes"></app-loading-input>
                <select *ngIf="guzergahType?.carTypes" class="form-control" [(ngModel)]="aracTipiId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let l of guzergahType?.carTypes" [ngValue]="l.id">{{l.name}}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-2">
              <div class="mb-3">
                <div class="form-label">Boş-Dolu</div>
                <select class="form-control" [(ngModel)]="bosDolu" [ngModelOptions]="{standalone: true}">
                  <option [value]=null selected></option>
                  <option [value]=1>Boş/Dolu</option>
                  <option [value]=2>Dolu/Dolu</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-lg-2">
              <div class="mb-3">
                <label class="form-label">Fiyat</label>
                <div class="input-icon">
                  <input type="number" class="form-control" [(ngModel)]="fiyat">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <div class="btn btn-success" (click)="ekle()">Ekle</div>
        </div>
      </div>
    </div>

  </div>
</app-layout>